import { type TranslationKeys } from '../types/locale';

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,24}$/;

export const PASSWORD_ERROR_MESSAGE: TranslationKeys = 'zodErrors.password';

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const PLAIN_TEXT_WITH_EMOJI_REGEX =
	/^[\p{L}\p{N}()[\]{}\-.,!?@#$%^&*+=:;'"\s\u{1F300}-\u{1FAFF}]+$/gu;

export const PLAIN_TEXT_WITH_EMOJI_ERROR_MESSAGE: TranslationKeys =
	'zodErrors.plainTextWithEmoji';

export const OBJECT_ID_REGEX = /^[0-9a-fA-F]{24}$/;

export const OBJECT_ID_ERROR_MESSAGE: TranslationKeys =
	'zodErrors.invalidObjectIdFormat';

export const UUID_REGEX =
	/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;

export const UUID_ERROR_MESSAGE: TranslationKeys =
	'zodErrors.invalidUuidFormat';
